import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children }) {
  return (
    <x-modal data-id="filter" className="group/filter flex flex-col">
      <button
        data-modal-role="toggle"
        data-modal-parent="filter"
        className="flex h-14 w-full items-center justify-between md-max:px-4"
      >
        <span>{label}</span>
        <Icon id="plus" className="shrink-0 group-data-visible/filter:hidden" />
        <Icon id="minus" className="hidden shrink-0 group-data-visible/filter:block" />
      </button>
      <div className="relative flex max-h-0 flex-col overflow-y-auto transition-all group-data-visible/filter:max-h-96 md-max:px-4">
        {children}
        <div className="sticky inset-x-0 bottom-0 z-10 h-10 shrink-0 bg-gradient-to-b from-white/0 to-white"></div>
      </div>
    </x-modal>
  )
}
